import IMask from "imask";

export default class Forms {
    constructor() {
        this.applyMasks();
    }

    static config() {
        return {
            fieldClass: 'error-field',
            disableSubmit: true,
            messageAfterGroup: false,    // evita criar mensagens para grupos (radio/checkbox)
        messageCustom: () => ''      // garante que não há conteúdo default
        };
    }

    static messages() {
        return {
            missingValue: { /* mesmo que antes */ },
            patternMismatch: { /* mesmo que antes */ },
            outOfRange: { /* mesmo que antes */ },
            wrongLength: { /* mesmo que antes */ },
            isNotZero: "Por favor selecione uma opção válida.",
        };
    }

    static activeErros(form) {
        const campos = form.querySelectorAll('[required]');

        campos.forEach(field => {

            // ---- RADIO GROUP ----
            if (field.type === 'radio') {
                const group = form.querySelectorAll(`input[name="${field.name}"]`);
                const algumMarcado = Array.from(group).some(r => r.checked);

                const erroCampo = field.closest('.form-line-radio')?.querySelector('.erro-campo');

                if (algumMarcado) erroCampo?.classList.add('hidden');
                else erroCampo?.classList.remove('hidden');

                return;
            }

            // ---- CHECKBOX ----
            if (field.type === 'checkbox') {
                const erroCampo = field.closest('.checkboxLine')?.querySelector('.erro-campo');

                if (field.checked) erroCampo?.classList.add('hidden');
                else erroCampo?.classList.remove('hidden');

                return;
            }

            // ---- CAMPOS NORMAIS ----
            const erroCampo = field.closest('.form-line, .form-line-radio, .checkboxLine')?.querySelector('.erro-campo');

            const temErro = field.classList.contains('error-field');

            // Mostra/oculta erro
            if (temErro) erroCampo?.classList.remove('hidden');
            else erroCampo?.classList.add('hidden');

            // --- NOVO: se o input estiver dentro de .addPrefixInput, aplicar erro no wrapper ---
            const prefixWrapper = field.closest('.addPrefixInput');

            if (prefixWrapper) {
                if (temErro) prefixWrapper.classList.add('error-field');
                else prefixWrapper.classList.remove('error-field');
            }
        });
    }



    applyMasks() {
        document.querySelectorAll(".telMask").forEach(field => IMask(field, { mask: "(00) 00000-0000" }));
        document.querySelectorAll(".dateMask").forEach(field => IMask(field, {
            mask: Date,
            pattern: "d/`m/`Y",
            blocks: {
                d: { mask: IMask.MaskedRange, from: 1, to: 31 },
                m: { mask: IMask.MaskedRange, from: 1, to: 12 },
                Y: { mask: IMask.MaskedRange, from: 1900, to: 2099 }
            }
        }));
        document.querySelectorAll(".moneyMask").forEach(field => {
        field.addEventListener('input', (e) => {
            let value = e.target.value.replaceAll(/\D/g, '');

            if (!value) {
                e.target.value = "0,00";
                return;
            }

            value = new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Number.parseInt(value, 10) / 100);

            e.target.value = value;
        });
    });

        document.querySelectorAll(".cpfMask").forEach(field => IMask(field, { mask: "000.000.000-00" }));
        document.querySelectorAll(".cnpjMask").forEach(field => IMask(field, { mask: "00.000.000/0000-00" }));
    }

    static loadRecaptcha() {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
        const locale = document.querySelector('meta[name="locale"]')?.getAttribute('content');
        if (!siteKey) return;

        if (!document.querySelector('script[src*="recaptcha/api.js"]')) {
            const url = `https://www.google.com/recaptcha/api.js?render=${siteKey}&hl=${locale || 'pt-BR'}`;
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = url;
            document.head.appendChild(s);
        }

        if (!globalThis.reloadCaptcha) {
            globalThis.reloadCaptcha = function(action, fieldName = 'g-recaptcha-response', fn = null) {
                const setToken = (token) => {
                    const inputElement = document.querySelector(`input[name='${fieldName}']`);
                    if (inputElement) inputElement.value = token;
                    if (fn) fn();
                };

                const execute = () => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(siteKey, { action }).then(setToken);
                    });
                };

                if (globalThis.grecaptcha === undefined) {
                    const wait = setInterval(() => {
                        if (globalThis.grecaptcha !== undefined) {
                            clearInterval(wait);
                            execute();
                        }
                    }, 100);
                } else {
                    execute();
                }
            };
        }
    }

    static initRecaptchaOnFocus(form) {
        const fields = form.querySelectorAll('input, select, textarea');
        fields.forEach(field => {
            field.addEventListener('focus', () => {
                Forms.loadRecaptcha();
                if (globalThis.reloadCaptcha !== undefined) {
                    const tokenInput = form.querySelector("input[name='g-recaptcha-response']");
                    if (!tokenInput) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'g-recaptcha-response';
                        form.appendChild(input);
                    }
                    globalThis.reloadCaptcha('form_load', 'g-recaptcha-response');
                }
            }, { once: true });
        });
    }

    static refreshRecaptchaToken(form, action = 'form_submit') {
        if (typeof globalThis.reloadCaptcha === 'function') {
            const input = form.querySelector("input[name='g-recaptcha-response']");
            if (input) globalThis.reloadCaptcha(action, 'g-recaptcha-response');
        }
    }
}
